const STORAGE_KEY = "recentlyViewedTrips";
const MAX_ENTRIES = 8;

function readRawList() {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (!stored) return [];
  const parsed = JSON.parse(stored);
  return Array.isArray(parsed) ? parsed : [];
}

// TourProperties (the shared trip-card renderer, reused here for visual consistency with the
// rest of the site) reaches into these fields without optional chaining - item.dateRange.start,
// item.flight.outboundFlight.departureDate, etc. A malformed/partial localStorage entry (an old
// schema version, manual tampering, a trip the backend later stops returning some field for)
// would otherwise crash the whole homepage over a single bad card. Validate the shape up front
// and just drop anything that doesn't look renderable.
function isRenderableTrip(trip) {
  return Boolean(
      trip &&
      trip.id &&
      trip.destination?.name &&
      trip.dateRange?.start &&
      trip.dateRange?.end &&
      trip.flight?.outboundFlight?.departureDate &&
      trip.flight?.returnFlight?.departureDate &&
      trip.pricePerPerson !== undefined &&
      trip.priceWithCurrencyPerDay?.amount !== undefined
  );
}

/**
 * Snapshots the trip as viewed (not just its id) into localStorage, so the homepage's "Ostatnio
 * oglądane" strip can render a card straight away, without a fetch per entry, and can still show
 * *something* if the trip later expires/changes upstream. Freshness (exact current price, etc.)
 * isn't critical for a recently-viewed list; not breaking is.
 *
 * Dedupes by id (moves the trip to the front instead of adding a second copy) and caps the list
 * at MAX_ENTRIES, dropping the oldest.
 */
export function recordRecentlyViewedTrip(trip) {
  if (typeof window === "undefined" || !trip?.id) return;
  try {
    const withoutCurrent = readRawList().filter((item) => item?.id !== trip.id);
    const next = [trip, ...withoutCurrent].slice(0, MAX_ENTRIES);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (error) {
    // localStorage can throw (private browsing, quota, disabled) - recording a "recently viewed"
    // entry should never break the trip page itself.
    console.warn("Could not record recently viewed trip", error);
  }
}

/** Reads the stored list, silently dropping anything malformed/stale rather than throwing. */
export function getRecentlyViewedTrips() {
  if (typeof window === "undefined") return [];
  try {
    return readRawList().filter(isRenderableTrip);
  } catch (error) {
    console.warn("Could not read recently viewed trips", error);
    return [];
  }
}
